import { render } from "./Caiwu.vue?vue&type=template&id=373ef756"
import script from "./Caiwu.vue?vue&type=script&lang=js"
export * from "./Caiwu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__